(function() {
   var FontFaceObserver = require("../../node_modules/fontfaceobserver/fontfaceobserver.js");
   // if the class is already set, we're good.
   var html = document.documentElement;
   if (sessionStorage.fontsLoaded) {
      html.classList.add('fonts-loaded');
   }

   //first stage fonts have highest priority, greatest impact on reflow

   var corantohead = new FontFaceObserver('Coranto W01 Headline', {
      style: 'normal',
      weight: '700'
   });
   var proximareg = new FontFaceObserver('proxima_nova', {
      style: 'normal',
      weight: 'normal'
   });

   //second stage fonts

   var proximabold = new FontFaceObserver('proxima_nova', {
      style: 'normal',
      weight: '700'
   });
   var coranto = new FontFaceObserver('Coranto W01', {
      style: 'normal',
      weight: '400'
   });
   var corantoit = new FontFaceObserver('Coranto W01', {
      style: 'italic',
      weight: '400'
   });
   var proximaregit = new FontFaceObserver('proxima_nova', {
      style: 'italic',
      weight: 'normal'
   });
   var proximaboldit = new FontFaceObserver('proxima_nova', {
      style: 'italic',
      weight: '700'
   });
   Promise
      .all([
         corantohead.load(),
         proximareg.load()
      ])
      .then(function () {
         console.log('Primary font is available');
         html.classList.add('fonts-loaded');
      });
   Promise
      .all([
         proximabold.load(),
         coranto.load(),
         corantoit.load(),
         proximaregit.load(),
         proximaboldit.load()
      ])
      .then(function () {
          console.log('Secondary fonts are available');
         sessionStorage.fontsLoaded = true;
      }).catch(function () {
         sessionStorage.fontsLoaded = false;
      });
})();


// WEBPACK FOOTER //
// ./js/fonts.js